// extracted by mini-css-extract-plugin
export var strike = "styles-module--strike--DxGji";
export var ctaBanner = "styles-module--ctaBanner--tW02J";
export var buttons = "styles-module--buttons--BlWNc";